import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#260a23] text-white pt-16 pb-8">
      <div className="max-w-[1400px] mx-auto px-8 md:px-14">
        <div className="text-center mb-14 border-b border-white/10 pb-14">
          <p className="text-amber-400/70 text-xs tracking-widest uppercase mb-3 font-light">Ma Gádeni</p>
          <h2 className="text-3xl md:text-4xl font-light text-white/90" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {t('footer_tagline')}
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <nav className="flex flex-wrap gap-6 justify-center md:justify-start">
            <Link to="/contact" className="text-white/50 hover:text-white/80 text-xs tracking-widest uppercase transition-colors whitespace-nowrap">{t('footer_contact')}</Link>
            <Link to="/our-story" className="text-white/50 hover:text-white/80 text-xs tracking-widest uppercase transition-colors whitespace-nowrap">{t('footer_about')}</Link>
            <Link to="/catalogo" className="text-white/50 hover:text-white/80 text-xs tracking-widest uppercase transition-colors whitespace-nowrap">{t('footer_whiskies')}</Link>
          </nav>

          <div className="flex items-center gap-5">
            <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-amber-400 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-amber-400 transition-colors cursor-pointer">
              <i className="ri-facebook-line text-lg"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-amber-400 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-amber-400 transition-colors cursor-pointer">
              <i className="ri-linkedin-line text-lg"></i>
            </a>
          </div>

          <p className="text-white/30 text-xs tracking-wide whitespace-nowrap">
            {t('footer_rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
